export default {
  methods: {
    isExternalUrl (url) {
      return url.includes(':')
    },
    // Canonical resolver for every Strapi media/file URL.
    //
    // With the S3 upload provider (assets platform), Strapi stores ABSOLUTE
    // CDN urls (https://assets[-test].motec.com.au/strapi/...) — those pass
    // through untouched. Legacy relative urls (/uploads/...) still get the
    // cmsURL prefix, so a half-migrated database renders correctly and this
    // frontend can deploy before or after the data migration.
    //
    // Also normalizes the joining slash (fixes the historical double-slash in
    // link/Image.vue and guards against un-slashed inputs).
    assetUrl (url) {
      if (!url) {
        return url
      }
      if (this.isExternalUrl(url)) {
        return url
      }
      return this.$config.cmsURL + (url.startsWith('/') ? url : '/' + url)
    },
    fullUrl (link) {
      if (link) {
        return this.isExternalUrl(link) ? link : this.$config.cmsURL + link
      } else {
        return null
      }
    },
    thumbnailImageUrl (image) { // max 208px
      if (!image) {
        return null
      }
      if (!image.formats || !image.formats.thumbnail) {
        return this.assetUrl(image.url)
      }
      return this.assetUrl(image.formats.thumbnail.url)
    },
    smallImageUrl (image) { // max 500px
      if (!image) {
        return null
      }
      if (!image.formats || !image.formats.small) {
        return this.assetUrl(image.url)
      }
      return this.assetUrl(image.formats.small.url)
    },
    mediumImageUrl (image) { // max 750px
      if (!image) {
        return null
      }
      if (!image.formats || !image.formats.medium) {
        return this.assetUrl(image.url)
      }
      return this.assetUrl(image.formats.medium.url)
    },
    largeImageUrl (image) { // max 1000px
      if (!image) {
        return null
      }
      if (!image.formats || !image.formats.large) {
        return this.assetUrl(image.url)
      }
      return this.assetUrl(image.formats.large.url)
    }
  }
}
